export const operators = {
  field: {
    url: 'URL',
    id: 'ID',
    type: 'type',
    login: 'Gabung',
    pass: 'Kata sandi',
    campaigns_name: 'Kampanye',
    weight: 'Berat operator',
    status: 'Status',
    wrtc: 'WRTC',
    instance: 'Server',
    created_at: 'Dibuat di'
  },

  button: {
    create: 'Dibuat operators',
    disabled: 'All webhooks are already created'
  },

  modal: {
    create: 'Dibuat operator',
    edit: 'Sunting operator',
    remove: {
      content: 'Anda yakin ingin menghapus {type}?'
    },
    change_status: {
      enable: 'Apakah Anda yakin ingin mengaktifkan operator?',
      disable: 'Apakah Anda yakin ingin menonaktifkan operator?'
    }
  },
  tooltip: {
    delete: 'Hapus keterampilan operator'
  },

  error: {
    create_project: 'Gagal membuat produk',
    unique_create_project:'Produk dengan nama ini sudah ada',
    create_skill: 'Gagal membuat keterampilan',
    edit_skill: 'Gagal mengubah skill'
  },
  skills: {
    title: 'Keahlian operator',
    add: '+ Tambahkan keterampilan operator',
    product: 'Produk',
    weight: 'Nilai keterampilan',
    create: 'Buat produk',
    edit: 'Mengedit produk',
    name: 'Nama produk'
  }
};
